export default __webpack_public_path__ + "ui/assets/img/arrow-up-32.svg";